import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressModalComponent } from '../../modals/address-modal/address-modal.component';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserInfoComponent {
  @Input() customer: any;

  openedSections = {
    about: true,
    payment: true,
    addresses: true
  };

  constructor(
    private modalService: NgbModal,
    private sharedDataService: SharedDataService,
    private profileService: ProfileService,
    private loaderService: LoaderService
  ) { }
  toggleSection(section: 'about' | 'payment' | 'addresses') {
    this.openedSections[section] = !this.openedSections[section];

    console.log(this.customer);
  }

  isAddressModalOpen: boolean = false;
  isAccountSettingsModalOpen: boolean = false;
  activeAccountSettingsTab: string = 'general';

  openAddressModal(): void {
    // this.isAddressModalOpen = true;
    const modalRef = this.modalService.open(AddressModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
  }

  // closeAddressModal(): void {
  //   this.isAddressModalOpen = false;
  // }

  openAccountSettingsModal(tab: string): void {
    this.activeAccountSettingsTab = tab;
    this.isAccountSettingsModalOpen = true;
  }

  closeAccountSettingsModal(): void {
    this.isAccountSettingsModalOpen = false;
  }

  deleteAddress(id: any) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.profile.you_want_to_delete_address,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.no_cancel_it
    }).then(result => {
      this.loaderService.startLoading();
      this.profileService.deleteAddress({ 'id': id }).subscribe({
        next: (res) => {
          this.loaderService.stopLoading();
          this.sharedDataService.setItem('customerInfo', res);
          Swal.fire(i18n.alert.success, i18n.profile.deleted_address, 'success');
        },
        error: (err) => {
          this.loaderService.stopLoading();
          const errors = err.error?.errors;
          console.log(errors);

        },
      });
    });
  }
}